import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import "./History.css";

export const History = () => {
  const params = useParams();
  const [updated, setUpdated] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [token, setToken] = useState();
  const [updateCode, setUpdateCode] = useState();
  const [orders, setOrders] = useState([]);
  const [ratingTypes, setRatingTypes] = useState([]);
  const [showDescriptions, setShowDescriptions] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [expired, setExpired] = useState(false);
  useEffect(() => {
    // get user history
    if (params.code) {
      fetch('/csrf', {
      }).then(response => {
        setToken(response.headers.get('X-CSRFToken'));
        setUpdateCode(params.code);
        fetch(`/orderhistory/${params.code}`, {
        }).then(response => {
          response.json().then(data => {
            if (data.expired) {
              setExpired(true);
            } else {
              setLoaded(true);
              if (data.ok) {
                console.log(data);
                setOrders(data.orders);
                setRatingTypes(data.rating_types);
              }
            }
          })
        })
      })
    }
  }, []);

  const updateHistory = async () => {
    console.log(orders);
    setUpdating(true);
    const response = await fetch(`/orderhistory/${params.code}`, {
      method: "POST",
      headers: {"Content-Type": "application/json", "X-CSRFToken": token},
      body: JSON.stringify({orders: orders})
    });
    const data = await response.json();
    setUpdating(false);
    if (data.ok) {
        setUpdated(true);
        window.scrollTo(0, 0)
    } else if (data.error) {
    }


  };

  const ratingChange = (index, event) => {
    let newOrders = [...orders];
    newOrders[index].rating = event.target.value;
    setOrders(newOrders);
  };

  const notesChanged = (index, event) => {
    let newOrders = [...orders];
    newOrders[index].notes = event.target.value;
    setOrders(newOrders);
  }

  const showDescription = (index) => {
    console.log('clicked')
    let newDescriptions = {...showDescriptions};
    if (index in newDescriptions) {
      delete newDescriptions[index];
    } else {
      newDescriptions[index] = true;
    }
    setShowDescriptions(newDescriptions);
  };

  const checkDescriptionVisible = (index) => {
    return index in showDescriptions;
    //return true;
  };

  return (
    <div>
    { expired ?
    <div className="historyExpired">This page has expired</div>
    :
    <div className="historyContainer">
      <div className="historyTitle">
        My Drops History
      </div>
      { updated &&
        <div className="historyUpdated">History Updated</div>
      }
      <div>
      </div>
      <div className="historyHeader">
        <div className="historyNameHeader">Name</div>
        <div className="historyImageHeader">Image</div>
        {/*<div className="historyDateHeader">Date</div>*/}
        <div className="historyRatingHeader">Rating</div>
        <div className="historyNotesHeader">Notes</div>
      </div>
      <div className="historyList">
      { orders.map((order,i) => (
        <div key={i} className="historyRow">
          <div className="historyName">
            <div className="historyNameRow">
              <div className="historyNameText">{order.drop}</div>
              <div className="historyNameDate">{order.date}</div>
            </div>
            <div className="historyDescriptionButton" onClick={() => showDescription(i)}>
              {checkDescriptionVisible(i) ? <span>Hide Description</span> : <span>Show Description</span>}
            </div>
            {checkDescriptionVisible(i) &&
            <div className="historyDescription">
              {order.description}
              <div className="historyImageMobile"><img src={order.image_url}/></div>
            </div>
            }
          </div>
          <div className="historyImage"><img src={order.image_url}/></div>
          {/*<div className="historyDate">{order.date}</div>*/}
          <div className="historyRating">
            <select onChange={(e) => ratingChange(i, e)}>
              <option key={0} value="">Select Rating</option>
              { ratingTypes.map((rating, j) => (
                <option key={j} value={rating} selected={rating == order.rating}>{rating}</option>
              ))
              }
            </select>
          </div>
          <div className="historyNotes">
            <div className="historyNotesLabel">
              <div className="historyNotesLabelText">
                Notes:
              </div>
              <div className="historyNotesRatingMobile">
                <select onChange={(e) => ratingChange(i, e)}>
                  <option key={0} value="">Select Rating</option>
                  { ratingTypes.map((rating, j) => (
                    <option key={j} value={rating} selected={rating == order.rating}>{rating}</option>
                  ))
                  }
                </select>
              </div>
            </div>
            <textarea className="historyNotesText" onChange={(e) => notesChanged(i, e)} value={order.notes}></textarea>
          </div>
        </div>
      ))
      }
      </div>
      <div className="historyUpdate">
        <div className="historyUpdateButton" onClick={() => updateHistory()} disabled={updating}>
          <div className="historyUpdateButtonText">Update</div>
        </div>
      </div>
    </div>
    }
    </div>
  )
};
